module.exports = __webpack_public_path__ + "img/cart-menu-cart.eb72c3a7.png";